"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
var textUtilities_1 = require("../../../util/textUtilities");
exports.localText = {
    title: function (numberOfItems, name) { return (0, textUtilities_1.maybePluralize)(numberOfItems, name || 'Item'); },
    placeholder: function (count, noun, pluralNoun) {
        return "Search ".concat((0, textUtilities_1.maybePluralize)(count, noun, pluralNoun).toLowerCase(), "...");
    },
    placeholderLoading: function (items) { return "Please wait while the ".concat(items.toLowerCase(), " are loading..."); },
    noResults: 'No Results',
};
